<div class="mos-u-spacer--margin-bottom-md">
  <atlas-card class="dsp-mobile-opening-card" [fullWidth]="true" [elevation]="'raised'" [headerPaddingClass]="''"
    [contentPaddingClass]="''">
    <atlas-card-header class="dsp-mobile-opening-card-header">
      <h3 class="dsp-mobile-opening-card-title">{{ transaction.description }}</h3>
    </atlas-card-header>
    <atlas-card-content class="dsp-mobile-card-content">
      <span class="dsp-mobile-card-label">
        Amount Currency
      </span>
      <span class="dsp-mobile-card-value dsp-numeric-font">
        ${{ transaction.amount | decimal }}
      </span>
      <div class="dsp-mobile-card-row">
        <div class="dsp-mobile-card-column">
          <span class="dsp-mobile-card-small-label">
            Unit Price*
          </span>
          <strong class="dsp-mobile-card-small-value dsp-numeric-font">
            ${{ transaction.unitPrice | decimal }}
          </strong>
        </div>

        <div class="dsp-mobile-card-column">
          <span class="dsp-mobile-card-small-label">
            Unit Balance
          </span>
          <strong class="dsp-mobile-card-small-value dsp-numeric-font">
            {{ transaction.unitBalance | decimal }}
          </strong>
        </div>
      </div>
    </atlas-card-content>
  </atlas-card>
</div>